import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "panzoomContainer",
  class: "panzoom-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf = _resolveComponent("pdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "d-flex justify-center w-full",
    style: {"overflow-y":"auto"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_pdf, {
              "data-cy": 'DocumentPDF_' + _ctx.documentId + '_pdf',
              source: _ctx.srcImport ? _ctx.srcImport : _ctx.src,
              page: _ctx.page,
              rotation: _ctx.rotation,
              resize: _ctx.resize,
              style: {"width":"100%","height":"100%"}
            }, null, 8, ["data-cy", "source", "page", "rotation", "resize"])
          ], 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}